import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { OrigenesContabilidadConstant } from 'constants/index'

const TipoReporteFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO REPORTE' htmlFor='select-tipoReporte' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='tipoReporte'>
          {({ field }) => (
            <Form.Select {...field} id='select-tipoReporte' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
              <option value=''>Seleccionar</option>
              <option value={OrigenesContabilidadConstant.COMPRAS}>
                {OrigenesContabilidadConstant.__dictionary[OrigenesContabilidadConstant.COMPRAS].nombre}
              </option>
              <option value={OrigenesContabilidadConstant.VENTAS}>
                {OrigenesContabilidadConstant.__dictionary[OrigenesContabilidadConstant.VENTAS].nombre}
              </option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoReporteFormGroup)
